import {Component, EventEmitter, Input, Output} from '@angular/core';
import {GatewaySignals} from '@models/adminstration/gateway/gateway-configuration/gateway-signals';
import {GatewayArraysEditComponent} from '@components/administration/gateway/gateway-configuration/gateway-connections/gateway-arrays/gateway-arrays-edit/gateway-arrays-edit.component';
import {GatewayArray} from '@models/adminstration/gateway/gateway-configuration/gateway-array';
import {ModalService} from '@services/modal/modal.service';

@Component({
    selector: 'scitis-admin-gateway-arrays',
    templateUrl: './gateway-arrays.component.html',
    styleUrls: ['./gateway-arrays.component.scss'],
    standalone: false
})
export class GatewayArraysComponent {


  @Input()
  gatewaySignals: GatewaySignals[] = new Array<GatewaySignals>();

  @Input()
  superOrTechAdminRole: boolean = false;

  @Input()
  isEditable: boolean = false;

  @Output()
  arraysChangedEvent = new EventEmitter<boolean>();

  constructor(private modalService: ModalService) { }


  onAddArray(config: GatewaySignals){
    const modalRef = this.modalService.open(GatewayArraysEditComponent, {size: 'lg'});
    modalRef.componentInstance.gatewaySignalsConfig = config;
    modalRef.componentInstance.gatewayArray = new GatewayArray();
    modalRef.result.then((result) => {
      if(!config.arrays || config.arrays.length <= 0){
        config.arrays = [];
      }
      config.arrays.push(result as GatewayArray);
      this.arraysChangedEvent.emit(true);
    });
  }

  onRemoveArray(config: GatewaySignals, array: any){
    const index = config.arrays.indexOf(array);
    if (index >= 0) {
      config.arrays.splice(index, 1);
      this.arraysChangedEvent.emit(true);
    }
  }

  onEditArray(config: GatewaySignals, array: GatewayArray){
    const modalRef = this.modalService.open(GatewayArraysEditComponent, {size: 'lg'});
    modalRef.componentInstance.gatewaySignalsConfig = config;
    modalRef.componentInstance.gatewayArray = array;
    modalRef.result.then((result) => {
      array.name = result.name;
      array.datatype = result.datatype;
      array.values = result.values;
      this.arraysChangedEvent.emit(true);
    });
  }

}
